export default [{
  path: '/stage/service',
  name: 'stage-serviceBilling',
  title: '服务开单',
  component: () => import('@/views/stage/template/serviceBilling/index')
}];
